import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React, { ReactNode } from 'react';

const PREFIX = 'Gate';

const classes = {
  container: `${PREFIX}-container`,
  gateCard: `${PREFIX}-gateCard`,
  line: `${PREFIX}-line`,
  typography: `${PREFIX}-typography`
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.container}`]: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    flexDirection: 'column',
    alignSelf: 'stretch',
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(3)
  },

  [`& .${classes.gateCard}`]: {
    background: theme.palette.info.main,
    padding: theme.spacing(1),
    color: theme.palette.grey[900]
  },

  [`& .${classes.line}`]: {
    width: 4,
    backgroundColor: theme.palette.info.main,
    flexGrow: 1
  },

  [`& .${classes.typography}`]: {
    lineHeight: 'normal'
  }
}));

interface GateProps {
  children?: ReactNode;
}

const Gate = ({ children }: GateProps) => {
  return (
    <Root className={classes.container}>
      <div className={classes.line} />
      <Paper className={classes.gateCard}>
        <Typography variant="subtitle1" className={classes.typography} noWrap>
          {children}
        </Typography>
      </Paper>
    </Root>
  );
};

export default Gate;
